import React from 'react';
import LocalStorage from '../../../utils/extension/localstorage';
import { Typography } from '@mui/material';

const Email = ({ email }) => {
    const data = LocalStorage.getUserData();
    const userEmail = email || data?.email || '';
    return (
        <Typography
            className="font-base fw-700 font-roboto"
            sx={{
                color: '#9E9E9E'
            }}
            gutterBottom={false}
        >
            {userEmail}
        </Typography>
    );
};

export default Email;
